import ExpandLeftIcon from "@diligentcorp/atlas-react-icons/ExpandLeft.js";
import ExpandRightIcon from "@diligentcorp/atlas-react-icons/ExpandRight.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
const getPaginationTokens = (tokens) => {
    return Object.assign(Object.assign({}, tokens.component.pagination), { input: tokens.component.input, spacing: tokens.semantic.spacing, shadow: tokens.semantic.shadow, iconSize: tokens.semantic.iconSize });
};
const pagination = (tokens) => {
    const { table, standalone, spacing, shadow, iconSize } = getPaginationTokens(tokens);
    const { button: { active, inactive }, } = standalone;
    return {
        MuiTablePagination: {
            defaultProps: {
                SelectProps: {
                    variant: "outlined",
                },
            },
            styleOverrides: {
                root: {
                    fontSize: table.fontSize.value,
                    lineHeight: table.lineHeight.value,
                    flexGrow: 1,
                    overflow: "visible",
                    ".MuiTablePagination-spacer": {
                        order: 2,
                    },
                    ".MuiTablePagination-displayedRows, .MuiTablePagination-actions": {
                        order: 3,
                        fontSize: "inherit",
                    },
                    "..MuiInputBase-root": {
                        marginLeft: table.rowPerPage.title.gap.value,
                    },
                    ".MuiToolbar-root": Object.assign(Object.assign({}, applyTokens(table)), { ".MuiTablePagination-actions": {
                            marginLeft: table.rowPerPage.icon.gap.value,
                        }, ".MuiTablePagination-selectLabel": {
                            margin: 0,
                        } }),
                },
            },
        },
        MuiPagination: {
            defaultProps: {
                shape: "rounded",
                boundaryCount: 2,
            },
            styleOverrides: {
                root: {
                    paddingLeft: standalone.paddingHorizontal.value,
                    paddingRight: standalone.paddingHorizontal.value,
                    paddingTop: standalone.paddingVertical.value,
                    paddingBottom: standalone.paddingVertical.value,
                    gap: standalone.gap.value,
                },
            },
        },
        MuiPaginationItem: {
            defaultProps: {
                components: {
                    previous: ExpandLeftIcon,
                    next: ExpandRightIcon,
                },
            },
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(standalone.button)), { margin: spacing.none.value, minWidth: standalone.button.width.value, height: standalone.button.height.value, borderRadius: standalone.button.borderRadius.value, backgroundColor: inactive.default.backgroundColor.value, color: inactive.default.color.value, "&:hover": {
                        backgroundColor: inactive.hover.backgroundColor.value,
                    }, "&:active": {
                        backgroundColor: inactive.active.backgroundColor.value,
                    }, "&:focus": {
                        backgroundColor: inactive.active.backgroundColor.value,
                        boxShadow: shadow.focus.value.stringValue,
                    }, "&.Mui-disabled": {
                        backgroundColor: inactive.disabled.backgroundColor.value,
                        color: inactive.disabled.color.value,
                        opacity: 1,
                    }, "&.Mui-selected": {
                        backgroundColor: active.default.backgroundColor.value,
                        color: active.default.color.value,
                        "&:hover": {
                            backgroundColor: active.hover.backgroundColor.value,
                        },
                        "&:active": {
                            backgroundColor: active.active.backgroundColor.value,
                        },
                        "&:focus": {
                            backgroundColor: active.active.backgroundColor.value,
                        },
                        "&.Mui-disabled": {
                            backgroundColor: active.disabled.backgroundColor.value,
                            color: active.disabled.color.value,
                        },
                    }, "&.MuiPaginationItem-ellipsis": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }, ".MuiPaginationItem-icon": {
                        width: iconSize.lg.value,
                        height: iconSize.lg.value,
                        lineHeight: iconSize.lg.value,
                    }, "&:not(.Mui-disabled) .MuiPaginationItem-icon": {
                        color: standalone.scrollButton.color.value,
                    } }),
            },
        },
    };
};
export default pagination;
//# sourceMappingURL=pagination.js.map